<ng-container *ngIf="!state.alertBanner || state.alertBanner.length === 0">
<div *ngIf="state.open && !state.isAddNewUserScreen" class="kng-banner">
  <div class="kng-banner--text">
    <div class="kng-banner--image">
      <img class="kng-banner--warning" src="{{ state.bannerIcon.iconPath }}"
      alt="{{ state.bannerIcon.altText }}" tabindex="0"/>
    </div>
    <div class="banner-message" [innerHTML]="state.bannerMessage" tabindex="0" (click)="bannerClickHandler($event)"></div>
  </div>
  <button class="kng-banner--close" (click)="hideBanner()">
    <img src="{{ state.closeIcon.iconPath }}" alt="{{ state.closeIcon.altText }}"/>
  </button>
 </div>
 <div *ngIf="state.open && state.isAddNewUserScreen" class="kng-banner kng-banner-error">
  <div class="kng-banner--text">
    <div id="bannerMessage" class="banner-message" [innerHTML]="state.bannerMessage" tabindex="0" (click)="bannerClickHandler($event)"></div>
  </div>
  <button class="kng-banner--close" (click)="hideBanner()">
    <img src="{{ state.closeIcon.iconPath }}" alt="{{ state.closeIcon.altText }}"/>
  </button>
 </div>
</ng-container>

 <ng-container *ngIf="state.alertBanner && state.alertBanner.length > 0">
  <ng-container *ngFor="let banner of state.alertBanner; let i = index">
    <div *ngIf="banner.display === 'true'" class="kng-banner" [ngStyle]="{ 'border-top': handleBannerStyle(i) === true ? '8px solid var(--Blue-Darkest, #0B4173)' : '4px solid var(--White, #FFF)'}">
      <div class="kng-banner--text">
        <div class="kng-banner--image">
          <img class="kng-banner--warning" src="assets/action.svg" alt="action" tabindex="0"/>
        </div>
        <div class="banner-message" [innerHTML]="banner.bannerMessage" tabindex="0" (click)="bannerClickHandler($event)"></div>
      </div>
      <button class="kng-banner--close" (click)="headerBannerCloseHandler(i)" tabindex="0">
        <img src='assets/close-Icon.svg' alt="close"/>
      </button>
     </div>
  </ng-container> 
</ng-container>
